/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespCollectionsComponents_shippingFilters$ref = any;
export type SbRespCollectionsModules_shippingFilters$ref = any;
export type SbRespCollectionsModules_shippingFilters = ReadonlyArray<{
    readonly " $fragmentRefs": SbRespCollectionsComponents_shippingFilters$ref;
    readonly " $refType": SbRespCollectionsModules_shippingFilters$ref;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespCollectionsModules_shippingFilters",
  "type": "ShippingFilterType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespCollectionsComponents_shippingFilters",
      "args": null
    }
  ]
};
(node as any).hash = '7eec9dee98bd0402f377d170e195f69a';
export default node;
